import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { buildFieldReferenceLibrary, HashedDigestedFieldReferenceLibrary } from "@arup-mad-ds/dhub-forms-engine";
import { FieldReferenceLibrary } from "interfaces/FieldReference";
import { FormDeliveryStatus } from "interfaces/FormDeliveryStatus";
import { FormValues } from "models/FormRecord";

import { IRawForm } from "../../../models/Form";

interface State {
	active?: IRawForm;
	dfl?: HashedDigestedFieldReferenceLibrary;
	projectRef?: string;
	assetId?: string;
	recordId?: string;
	fieldReferenceLibrary: FieldReferenceLibrary;
	externalContext: { [formId: string]: FormValues };
	deliveryStatus: FormDeliveryStatus;
	isFrozen: boolean;
}

const initialState: State = {
	active: undefined,
	dfl: undefined,
	projectRef: undefined,
	assetId: undefined,
	recordId: undefined,
	fieldReferenceLibrary: {},
	externalContext: {},
	deliveryStatus: "inProgress",
	isFrozen: false,
};

export const formSlice = createSlice({
	name: "form",
	initialState,
	reducers: {
		setActive: (
			state,
			action: PayloadAction<
				Pick<
					State,
					"active" | "dfl" | "assetId" | "projectRef" | "recordId" | "externalContext" | "deliveryStatus" | "isFrozen"
				>
			>,
		) => {
			state.active = action.payload.active;
			state.dfl = action.payload.dfl;
			state.fieldReferenceLibrary = action.payload.active
				? buildFieldReferenceLibrary(action.payload.active.fields)
				: {};
			state.projectRef = action.payload.projectRef;
			state.assetId = action.payload.assetId;
			state.recordId = action.payload.recordId;
			state.externalContext = action.payload.externalContext;
			state.deliveryStatus = action.payload.deliveryStatus;
			state.isFrozen = action.payload.isFrozen;
		},
		reset: () => {
			return initialState;
		},
	},
});

export const actions = formSlice.actions;

export default formSlice.reducer;
